import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'echarts-liquidfill/src/liquidFill.js'; // 引入提示框

require('echarts/lib/component/tooltip'); // 引入标题组件


require('echarts/lib/component/title');

require('echarts/lib/component/legendScroll');

import { getAction } from '@/api/manage';
import instrument from '@/components/env-bigData/instrument'; // 空气质量指数进度图

import barType from '@/components/env-bigData/barType';
import overProof from '@/components/env-bigData/overProof'; // 日期格式化插件

import moment from 'moment';
import fileTable from '@/components/border/fileTable';
import Vue from 'vue';
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

Vue.use(VueAMap); // 初始化vue-amap

VueAMap.initAMapApiLoader({
  // 高德的key
  key: 'fff9f6d9570cff54e05b6bd3b1639fb0',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  v: '1.4.4'
});
var amapManager = new VueAMap.AMapManager(); // 预警组件

import warn from '@/components/border/warn'; // 超标因子

import trendSecond from '@/components/env-bigData/trendSecond'; // 超标统计
// import flower from '@/components/env-bigData/flower'

import ratio from '@/components/env-bigData/ratio'; //区域分析

import areaAnalysis from '@/components/env-bigData/areaAnalysis'; // 趋势折线图

import trend from '@/components/env-bigData/trend'; // 达标统计

import dial from '@/components/env-bigData/watch'; // 监测站点

import site from '@/components/env-bigData/site'; //边框组件

import border from '@/components/border/border';
import majorPollution from '@/components/env-bigData/majorPollution'; // 地图五角星

import { querySiteBySt, queryWarn, queryRealtime, mainRealtime as _mainRealtime, querySiteList, queryStandardTreeList, queryWastDateList, queryDateSkylist, ajaxGetDictItems } from '@/api/api'; // 水文监测

import servicePopulation from '@comp/bigData/servicePopulation'; // 预警统计

import warnStatistics from '@comp/bigData/warnStatistics'; // 水质趋势
// import warnStatisticsJinchu from '@comp/bigData/waterStatistics-jinchu'

import screenfull from 'screenfull';
import imgUrl from '@/assets/others/index/bg.gif';
import { commonRender } from '@/mixins/commonRender';
export default {
  mixins: [commonRender],
  data: function data() {
    return {
      showSelect: false,
      siteTypeobj: {},
      menuList: [],
      onlineNum: 0,
      siteDetail: {},
      selectType: 0,
      queryDateList: [],
      standList: [],
      showDrawer: false,
      showLeft: false,
      showTag: false,
      dateLists: [],
      firstPollution: {},
      markerList: [],
      siteInfo: {},
      headDate: '',
      headWeek: '',
      headTime: '',
      amapManager: amapManager,
      zoom: 12,
      center: [118.047928, 24.613341],
      mapStyle: 'amap://styles/darkblue',
      //设置地图样式
      plugin: [{
        pName: 'Geolocation',
        defaultType: 1,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      lines: [],
      markers: [],
      windows: [],
      window: null,
      waterWarnList: [],
      isFullscreen: false,
      waterTitle: '',
      // 表头
      columns: [],
      dataSource: [],
      inletStatus: '',
      loading: false,
      dataMap: null,
      dataMap2: null,
      dataMap3: null,
      dataMap4: null,
      dataMap5: null,
      dataMap6: null,
      siteName: '进口泵站',
      siteName2: '进口泵站',
      autoplaySpeed: 3000,
      swiperIndex1: 0,
      swiperIndex2: 0,
      imgUrl: require("../../../assets/others/index/bg.gif"),
      wrongUrl: require("../../../assets/others/index/wrong.png"),
      standState: false,
      standLabel: '',
      standText: ''
    };
  },
  created: function created() {
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];
    this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
    this.getStandard();
    this.getSite('');
    this.getSitetype();
  },
  mounted: function mounted() {
    var _this = this;

    moment.locale('zh-cn');
    this.getWarn('');
    setInterval(this.scroll, 1000);
    setInterval(function () {
      var date = new Date();
      _this.headDate = moment(date).format('YYYY年MM月DD日');
      _this.headWeek = moment(date).format('dddd');
    }, 60000); // this.getDate()

    setInterval(function () {
      _this.swiper();
    }, 60000);
    var date = new Date();
    var year1 = date.getFullYear() - 1 + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    var year2 = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    var year3 = date.getMonth() != 0 ? date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() : date.getFullYear() - 1 + '-12' + '-' + date.getDate();
    this.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 6);
    this.$nextTick(function () {
      _this.showSelect = true;
    });
    this.$refs.trend.initBarChart([{
      title: 'I类',
      data: [2, 5, 3, 6, 4, 5, 3, 12, 43, 12]
    }, {
      title: 'II类',
      data: [5, 3, 12, 43, 12, 43, 12, 32, 42, 12]
    }, {
      title: 'III类',
      data: [43, 12, 32, 42, 12, 21, 23, 43, 21, 2]
    }, {
      title: 'IV类',
      data: [21, 23, 43, 21, 2, 3, 2, 12, 43, 12]
    }, {
      title: 'V类',
      data: [3, 2, 12, 43, 12, 43, 23, 123, 12, 33]
    }, {
      title: '劣V类',
      data: [43, 23, 123, 12, 33, 2, 5, 3, 6, 4]
    }, {
      title: '一级',
      data: [2, 5, 3, 6, 4, 5, 3, 12, 43, 12]
    }, {
      title: '二级',
      data: [5, 3, 12, 43, 12, 43, 12, 32, 42, 12]
    }, {
      title: '三级',
      data: [43, 12, 32, 42, 12, 21, 23, 43, 21, 2]
    }, {
      title: '四级',
      data: [21, 23, 43, 21, 2, 3, 2, 12, 43, 12]
    }, {
      title: '五级',
      data: [3, 2, 12, 43, 12, 43, 23, 123, 12, 33]
    }, {
      title: '六级',
      data: [43, 23, 123, 12, 33, 2, 5, 3, 6, 4]
    }], ['2021-1-1', '2021-1-2', '2021-1-3', '2021-1-4', '2021-1-5', '2021-1-1', '2021-1-2', '2021-1-3', '2021-1-4', '2021-1-5']);
  },
  components: {
    instrument: instrument,
    barType: barType,
    fileTable: fileTable,
    warn: warn,
    trendSecond: trendSecond,
    ratio: ratio,
    areaAnalysis: areaAnalysis,
    trend: trend,
    dial: dial,
    site: site,
    servicePopulation: servicePopulation,
    warnStatistics: warnStatistics,
    border: border,
    overProof: overProof,
    majorPollution: majorPollution
  },
  methods: {
    toGetkey: function toGetkey(value, datas) {
      this.siteTypeobj = this.menuList[value.key];
    },
    getSitetype: function getSitetype() {
      var _this2 = this;

      ajaxGetDictItems('site_st').then(function (res) {
        if (res.success && res.result.length > 0) {
          _this2.menuList = res.result;
          _this2.siteTypeobj = res.result[0];
        }
      });
    },
    // changetadios(e){
    // 	this.defaultValues = e
    // 	if(e=='0') this.radioIndex = ''
    // 	else this.radioIndex = e
    // 	this.getWarn(this.radioIndex)
    // },
    onShowleft: function onShowleft() {
      var _this3 = this;

      this.showLeft = !this.showLeft;
      setTimeout(function () {
        _this3.showDrawer = !_this3.showDrawer;
      }, 500);
    },
    // 获取站点数据
    // getSitearr() {
    // 	let that = this
    // 	querySiteBySt().then((res) => {
    // 		if (res.success) {
    // 			let arr = []
    // 			let stand = {}
    // 			let windows = []
    // 			let arr2 = []
    // 			res.result.forEach((item, index) => {
    // 				if (item.longitude != 'NaN') item.position = [item.longitude, item.latitude]
    // 				else item.position = ['118.04792', '24.61334']
    // 				item.show = true
    // 				item.title = item.name
    // 				if (parseInt((item.st - 0) / 10) == 2 || parseInt((item.st - 0) / 10) == 5 || parseInt((item.st - 0) / 10) ==
    // 					6) {
    // 					if (item.currentStandard) {
    // 						if (item.st == '21') {
    // 							item.content = this.getCir(
    // 								item.currentStandard.color ? item.currentStandard.color : 'red',
    // 								item.currentStandard.title.replace('类', ''),
    // 								item.warnStatus,
    // 								item.onlineStatus,
    // 								item.name
    // 							)
    // 						} else if (item.st == '22') {
    // 							item.content = this.getRec(
    // 								item.currentStandard.color ? item.currentStandard.color : 'red',
    // 								item.currentStandard.title.replace('类', ''),
    // 								item.warnStatus,
    // 								item.onlineStatus,
    // 								item.name
    // 							)
    // 						} else if (parseInt((item.st - 0) / 10) == 5) {
    // 							item.content = this.getOval(
    // 								item.currentStandard.color ? item.currentStandard.color : 'red',
    // 								item.currentStandard.title.replace('类', ''),
    // 								item.warnStatus,
    // 								item.onlineStatus
    // 							)
    // 						}
    // 					} else {
    // 						item.content = this.getnoneRec('#ccc', item.name, item.warnStatus, item.onlineStatus)
    // 					}
    // 				} else if (parseInt((item.st - 0) / 10) == 3) {
    // 					if (item.upStandard) {
    // 						item.content = this.getCir(
    // 							'green',
    // 							'',
    // 							item.warnStatus,
    // 							item.onlineStatus,
    // 							item.name
    // 						)
    // 					} else if (item.upStandard == null) {
    // 						item.content = that.getCir(
    // 							'#ccc',
    // 							'',
    // 							item.warnStatus,
    // 							item.onlineStatus,
    // 							item.name
    // 						)
    // 					} else {
    // 						item.content = that.getCir(
    // 							'red',
    // 							'',
    // 							item.warnStatus,
    // 							item.onlineStatus,
    // 							item.name
    // 						)
    // 					}
    // 				}
    // 				(item.events = {
    // 					click() {
    // 						that.windows.forEach((window) => {
    // 							window.visible = false //关闭窗体
    // 						})
    // 						that.selectType = item.st
    // 						that.window = that.windows[index]
    // 						that.$nextTick(() => {
    // 							// this.mainRealtime(item.id)
    // 							that.window.visible = true //点击点坐标，出现信息窗体
    // 							that.getsiteDetail(item.id) //获取对应id的站点详情
    // 							// that.getwaterStand(item.id) //获取当前水质标准
    // 							that.getDateLists(item.id)
    // 							// that.getSkyList(item.id)
    // 							// that.getSiteInfo(item.id)
    // 							// that.queryOnlineById(item.id)
    // 							// that.loadData(item.id)
    // 						})
    // 					},
    // 				}),
    // 				(arr = [])
    // 				let positions
    // 				if (item.longitude != 'NaN') positions = [item.longitude, item.latitude]
    // 				else positions = that.center
    // 				windows.push({
    // 					position: positions,
    // 					offset: [10, -30], //窗体偏移
    // 					visible: false, //初始是否显示
    // 					name: item.name,
    // 					onlineStatus: item.onlineStatus,
    // 					siteId: item.id,
    // 				})
    // 				// return item
    // 			})
    // 			that.windows = windows
    // 			this.markerList = res.result
    // 		}
    // 	})
    // },
    // 获取国标数据
    getStandard: function getStandard() {
      var _this4 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          // res.result[0].children[0].children.forEach((item, index) => {
          //   item.data.title = item.data.title.replace('类', '')
          //   item.data.show = true
          //   return item
          // })
          var arr = [];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              arr = item.children;
            }
          });

          if (arr != null) {
            arr.forEach(function (item, index) {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  item1.statu = true;
                  item1.title = item1.title.replace('类', '');

                  if (item.key == 'K1_3') {
                    item1.class = 'map-tag-cir';
                  } else if (item.key == 'K1_2') {
                    item1.class = 'map-tag-rec';
                  }

                  return item1;
                });
              }

              return item;
            });
          }

          _this4.standList = arr;
        }
      });
    },
    changeRadioss: function changeRadioss(e) {},
    // 点击地图下对应的图标
    Ontoselectwater: function Ontoselectwater(index, index1, obj) {
      if (index == this.standList.length) {
        this.markerList.forEach(function (item, index) {
          if (!item.currentStandard) {
            item.show = !item.show;
          }

          return item;
        });
      } else {
        this.standList[index].children[index1].statu = !this.standList[index].children[index1].statu;
        this.markerList.forEach(function (item, index) {
          if (item.currentStandard) {
            if (item.currentStandard.title == obj.data.title && item.currentStandard.id == obj.data.id) {
              item.show = !item.show;
            }

            return item;
          }
        });
      } // for (let i = 0; i < this.markerList.length; i++) {
      //   if (this.markerList[i].st == st && this.markerList[i].id == id) {
      //     this.markerList[i].show = !this.markerList[i].show
      //   }
      // }
      // }
      // this.markers = this.markers.splice(1)

    },
    Ontoselectgas: function Ontoselectgas(index) {
      this.gasTaglist[index].statu = !this.gasTaglist[index].statu; // this.markers = this.markers.splice(1)
    },
    Ontoselectoil: function Ontoselectoil(index) {
      this.soilTaglist[index].statu = !this.soilTaglist[index].statu; // this.markers = this.markers.splice(1)
    },
    swiper: function swiper() {// if (this.swiperIndex1 < 5) {
      //   this.$refs.swiper1.goTo(this.swiperIndex1 + 1)
      // } else {
      //   this.$refs.swiper1.goTo(0)
      // }
      // if (this.swiperIndex2 < 5) {
      //   this.$refs.swiper2.goTo(this.swiperIndex2 + 1)
      // } else {
      //   this.$refs.swiper2.goTo(0)
      // }
    },
    mainRealtime: function mainRealtime(id) {
      var that = this;
      that.columns = [];
      that.dataSource = [];

      _mainRealtime({
        siteId: id
      }).then(function (res) {
        res.result.factorMap.all.forEach(function (e, i) {
          that.columns.push({
            title: e.title,
            align: 'center',
            width: '100px',
            dataIndex: e.code,
            customRender: function customRender(text, record, index) {
              return that.renderCol(e.code, text, record);
            }
          });
        });
        that.dataSource = res.result.records;
      });
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    getDate: function getDate() {
      var _this5 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headWeek = moment(date).format('dddd');
      this.headTime = moment(date).format('HH:mm:ss');
      setInterval(function () {
        var time = new Date();
        _this5.headTime = moment(time).format('HH:mm:ss');

        _this5.$forceUpdate();
      }, 1000);
    },
    scroll: function scroll() {
      var _this6 = this;

      setTimeout(function () {
        if (_this6.waterWarnList.length > 5) {
          _this6.waterWarnList.push(_this6.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this6.waterWarnList.shift(); //删除数组的第一个元素

        }

        if (_this6.dateLists.length > 7) {
          _this6.dateLists.push(_this6.dateLists[0]); // 将数组的第一个元素添加到数组的


          _this6.dateLists.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    },
    toData: function toData() {
      this.$router.push('/ds/siteindex');
    }
  }
};